<template>
  <div>
    <Header />
    <div class="content">
      <div class="trainee-heading">
        <h1>Your Logbooks:</h1>
        <button @click="openSignatureModal" class="inspdfButton">Signature</button>
      </div>
      <div v-if="processing" class="no-projects-message">
        <p style="color: #777777; margin-bottom: 0px;">Loading ...</p>
      </div>
      <div v-if="logbooks.length === 0 && !processing" class="no-projects-message">
        <p style="color: rgb(216, 4, 4); margin-bottom: 0px;">You have no assigned logbooks.</p>
      </div>
      <!-- Display the list of current products -->
      <div class="product-container">
        <div v-for="logbook in logbooks" :key="logbook.logbook_id"
          @click="openLogbook(logbook.logbook_id, logbook.product_id, logbook.project_id)" class="product-box"
          :class="{ locked: logbook.locked }">
          <div class="product-card">
            <div class="section id-section">
              <div class="id-row">
                <p class="logbook-id" style="font-size: 16px; padding-left: 0px;">
                  <b>ID: {{ logbook.logbook_id }}</b>
                  <span v-if="logbook.locked" class="lock-icon">🔒 Locked</span>
                </p>
              </div>
              <h2 class="logbook-name" style="font-size: 16px;">{{ logbook.name }}</h2>
              <!-- <span class="product-name"><b>Practical Element: </b> <br>{{ logbook.productName }}</span> -->
            </div>
            <div class="section tasks-section">
              <!-- <p><span class="label">MT/AT:</span><span class="value">{{ logbook.totalTasks }}</span></p> -->
              <p><span class="label">Assigned:</span><span class="value">{{ logbook.enabledTasks }}</span></p>
              <p><span class="label">Incomplete:</span><span class="value">{{ logbook.remainingTasks }}</span></p>
            </div>

            <div class="section tasks-section">
              <p><span class="label">Main Tasks:</span><span class="value">{{ logbook.mainTasks }}</span></p>
              <p><span class="label">Complete:</span><span class="value">{{ logbook.mainCompleted }}</span></p>
              <p><span class="label">Percent:</span><span class="value" :class="{ 'percent-green': logbook.completedPercent >= logbook.passRate, 'percent-orange': logbook.completedPercent < logbook.passRate }">{{ logbook.completedPercent }}%</span></p>
            </div>

            <div v-if="!getEvaluationStatusText(logbook.logbook_id)" class="section trainee-section">
              <p class="instructor-email">Instructor: {{ logbook.instructorName }}</p>
              <p class="instructor-email">Email: {{ logbook.instructorEmail }}</p>
            </div>
            <div v-if="getEvaluationStatusText(logbook.logbook_id)" class="section trainee-section">
              <div class="evaluation-status-container">
                <div
                  v-if="getEvaluationStatusText(logbook.logbook_id)"
                  :class="getEvaluationStatusClass(logbook.logbook_id)"
                  class="evaluation-status-box"
                >
                  {{ getEvaluationStatusText(logbook.logbook_id) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <signature-modal v-if="showSignatureModal" role="trainee" @close="closeSignatureModal"></signature-modal>
  </div>
</template>

<script>
import Header from '../Examiner/Header.vue';
import axios from 'axios';
import SignatureModal from '@/components/Examiner/SignatureModal.vue';

export default {
  name: 'TraineeHome',
  data() {
    return {
      processing: false,
      logbooks: [],
      currentTime: '',
      loggedInUser: '',
      showModal: false,
      showSignatureModal: false,
      evaluationMap: {},
    };
  },
  components: {
    Header,
    SignatureModal,
  },
  computed: {
    displayedRemainingTasks() {
      return this.logbook.enabledTasks > 0 ? this.logbook.remainingTasks : '-';
    }
  },
  mounted() {
    this.loadLogbooksForTrainee();
  },
  methods: {
    async openLogbook(logbookId, productId, projectId) {

      localStorage.setItem('logbook_id', logbookId);
      localStorage.setItem('productId', productId);
      localStorage.setItem('project_id', projectId);
      const logbook = this.logbooks.find(l => l.logbook_id === logbookId);
      if (logbook?.product) {
        localStorage.setItem('currentProduct', JSON.stringify(logbook.product));
      }
      let token = localStorage.getItem('token');
      if (!token) {
        this.$router.push({ name: 'examinerLogin' });
      }
      this.$router.push({ name: 'TraineeLogbook', params: { logbookId, productId } });
    },
    updateCurrentTime() {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');
      this.currentTime = `${hours}:${minutes}:${seconds}`;
    },
    async loadLogbooksForTrainee() {
      this.processing = true;

      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      try {
        // Single call returns the trainee's logbooks with product, KPIs, evaluations and instructor
        const result = await axios.get('/api/trainee/home-summary', { headers });
        const logbookMap = (result.data || []).map(logbook => ({
          ...logbook,
          passRate: logbook.passRate || 50,
          remainingTasks: logbook.incompleteTasks,
        }));

        this.evaluationMap = this.groupEvaluationsByLogbook(logbookMap.flatMap(logbook => logbook.evaluations || []));
        this.logbooks = logbookMap;

        if (logbookMap.length > 0) {
          localStorage.setItem('trainee_id', logbookMap[0].trainee_id);

          const uniqueInstructorIds = [
            ...new Set(
              logbookMap
                .map(lb => lb.instructorId)
                .filter(Boolean)
            )
          ];
          localStorage.setItem('instructorIds', JSON.stringify(uniqueInstructorIds));
        }

      } catch (error) {
        console.error('Error loading trainee logbooks:', error);

        if (error.response && error.response.status === 401) {
          this.$router.push({ name: 'LoginPage' });
        }
      } finally {
        this.processing = false;
      }
    },
    openSignatureModal(event) {
      try {
        this.showSignatureModal = true;
      } catch (error) {
        console.error('Error opening signature modal:', error);
        // If `error` is actually an Event object, this will help surface more info.
        console.error('Event details:', event);
      }
    },
    async closeSignatureModal() {
      this.showSignatureModal = false;
    },
    groupEvaluationsByLogbook(evaluations) {
      return (evaluations || []).reduce((acc, evaluation) => {
        const logbookId = evaluation.logbook_id;
        if (!acc[logbookId]) {
          acc[logbookId] = [];
        }
        acc[logbookId].push(evaluation);
        return acc;
      }, {});
    },
    getCurrentEvaluationForLogbook(logbookId) {
      const evaluations = this.evaluationMap[logbookId] || [];
      if (!evaluations.length) return null;

      const continuous = evaluations.find(e => e.evaluation_type === 'continuous') || null;
      const remedial = evaluations.find(e => e.evaluation_type === 'remedial') || null;

      if (remedial) {
        if (remedial.is_submitted === 1 || remedial.is_submitted === 2) {
          return remedial;
        }
        if (remedial.is_submitted === 0) {
          return continuous || null;
        }
      }

      return continuous || null;
    },
    getEvaluationStatusText(logbookId) {
      const evaluation = this.getCurrentEvaluationForLogbook(logbookId);
      if (!evaluation) return '';

      if (evaluation.is_submitted === 0) return 'Evaluation in progress';
      if (evaluation.is_submitted === 1) return 'Awaiting your signature';

      if (evaluation.is_submitted === 2) {
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'successful') {
          return 'Continuous evaluation passed';
        }
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'remedial') {
          return 'Continuous evaluation: remedial';
        }
        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'successful') {
          return 'Remedial evaluation passed';
        }
        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'unsuccessful') {
          return 'Remedial evaluation failed';
        }
        return 'Evaluation signed';
      }
      return '';
    },
    getEvaluationStatusClass(logbookId) {
      const evaluation = this.getCurrentEvaluationForLogbook(logbookId);
      if (!evaluation) return '';

      if (evaluation.is_submitted === 0) return 'pending-box';
      if (evaluation.is_submitted === 1) return 'pending-box';

      if (evaluation.is_submitted === 2) {
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'successful') {
          return 'success-box';
        }
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'remedial') {
          return 'expired-box';
        }
        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'successful') {
          return 'success-box';
        }
        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'unsuccessful') {
          return 'expired-box';
        }
        return 'success-box';
      }
      return 'pending-box';
    },
  },
};
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  font-weight: bold;
  /* Add space from the top */
}

.product-name {
  font-size: 12px;
  color: grey;
  margin-left: 0%;
  border: none;
  text-align: start;
}

.trainee-email,
.instructor-email {
  font-size: 0.9rem;
  color: grey;
  margin: 0;
  padding-top: 5px;
}

.product-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
  margin-bottom: 20px;
  width: 90%;
}

.product-card {
  background-color: #f3f8ff;
  padding: 10px 20px;
  border-radius: 8px;
  box-shadow:
    3px 3px 3px rgba(0, 0, 0, 0.2),
    -3px -3px 3px rgba(0, 0, 0, 0.2),
    0 0 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  cursor: pointer;
  width: 90vw;
  height: auto;
  margin-bottom: 2px;
  gap: 0px;
  height: 110px;
}

.logbook-name {
  font-size: 16px;
  font-weight: normal;
  color: #2c3e50;
  margin: 0;
  padding: 0px;
  padding-bottom: 10px;
  align-self: left;
  /* centers the name horizontally */
  text-align: left;
  width: 100%;
}

h2 {
  font-size: 16px;
  margin-left: 0px;
  line-height: 1.5;
}

h1 {
  font-size: 2rem;
  margin-top: 0;
  margin-bottom: 20px;
  margin-left: 40px;
  padding-top: 0px;
  top: 7px;
}

.section {
  flex-shrink: 0;
}

.section p {
  display: flex;
  justify-content: space-between;
  padding-left: 30px;
  padding-right: 30px;
}

.label {
  font-weight: bold;
}

.value {
  text-align: right;
  font-weight: bold;
}

.id-section {
  flex: 1;
  height: 100%;
  padding: 5px 0;
}

/* Optional: make the text cleaner */
.product-card h2,
.product-card p,
.product-card span {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  background-color: #f3f8ff;
  border: 1px solid #f3f8ff;
}

.logbook-id {
  font-size: 16px;
  font-weight: bold;
}

.tasks-section {
  width: 200px;
}

.trainee-section {
  width: 300px;
}

.date-section {
  width: 200px;
}


.product-card:hover {
  transform: scale(1.03);
  box-shadow:
    3px 3px 3px rgba(0, 0, 0, 0.2),
    -3px -3px 3px rgba(0, 0, 0, 0.2),
    0 0 3px rgba(0, 0, 0, 0.2);
}

.task-summary {
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
}

.task-summary p {
  margin-bottom: 2px;
  /* Adjust as needed to reduce the gap */
}

.inspdfButton {
  border-radius: 5px;
  width: 150px;
  height: 40px;
  background-color: #a52c0d;
  color: white;
  padding: 5px;
  font-size: 16px;
  border: 1px solid #491204;
  margin-right: 40px;
}

.inspdfButton:hover {
  background-color: #791e08;
}

.trainee-heading {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.no-projects-message {
  width: 95%;
  padding: 30px;
  border: 1px solid #dddddd;
  border-radius: 4px;
}


.id-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.lock-icon {
  color: #d80404;
  font-size: 14px;
  font-weight: bold;
  padding-left: 20px;
}

.product-box.locked {
  opacity: 0.8;
}

.percent-green {
  color: green;
  font-weight: bold;
}

.percent-green:hover {
  color: rgb(4, 107, 4) !important;
  font-weight: bold;
}

.percent-orange {
  color: rgb(205, 109, 0);
  font-weight: bold;
}

.percent-orange:hover {
  color: rgb(171, 92, 1) !important;
  font-weight: bold;
}

.evaluation-status-container {
  display: flex;
  justify-content: center;
  padding-right: 20px;
  margin-top: 5px;
}

.evaluation-status-box {
  width: auto;
  padding: 0px 8px;
  font-size: 13px;
  text-align: center;
  margin-left: 30px;
  margin-right: 10px;
}

.expired-box {
  padding-top: 8px;
  padding-bottom: 8px;
  margin-bottom: 20px;
  background-color: rgb(250, 190, 190);
  color: rgb(194, 0, 0);
  font-size: 14px;
  text-align: center;
  border: 1px solid rgb(201, 141, 141);
  border-radius: 5px;
  margin-bottom: 0;
  margin-left: 30px;
  justify-content: center;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  font-weight: 300;
}

.success-box {
  padding-top: 8px;
  padding-bottom: 8px;
  background-color: #b0e6bd;
  color: rgb(0, 119, 16);
  font-size: 14px;
  border: 1px solid #82c492;
  border-radius: 5px;
  margin-bottom: 0;
  justify-content: center;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  font-weight: 300;
}

.pending-box {
  padding-top: 8px;
  padding-bottom: 8px;
  background: rgb(255, 216, 144);
  color: rgb(160, 85, 0);
  font-size: 14px;
  border: 1px solid rgb(231, 189, 111);
  border-radius: 5px;
  margin-bottom: 0;
  justify-content: center;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  font-weight: 300;
}
</style>